import {
  AccordionDetails as AccordionDetailsMui,
  AccordionDetailsProps as AccordionDetailsPropsMui,
  Accordion as AccordionMui,
  AccordionProps as AccordionPropsMui,
  AccordionSummary as AccordionSummaryMui,
  AccordionSummaryProps as AccordionSummaryPropsMui
} from '@mui/material'
import { FC } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

type AccordionProps = AccordionPropsMui

export const Accordion: FC<AccordionProps> = ({ children, ...rest }) => {
  return (
    <AccordionMui
      sx={theme => ({
        '&': {
          border: '2px solid transparent',
          boxShadow: 'none',
          pb: 2,
          m: '0 !important'
        },
        '&:before': {
          display: 'none'
        },
        '&:last-child': {
          borderBottom: `1px solid ${theme.palette.divider}`
        },
        '&:not(:first-child)': {
          borderTop: `1px solid ${theme.palette.divider}`
        }
      })}
      {...rest}
    >
      {children}
    </AccordionMui>
  )
}

type AccordionDetailsProps = Pick<AccordionDetailsPropsMui, 'children'>

export const AccordionDetails: FC<AccordionDetailsProps> = ({ children, ...rest }) => {
  return <AccordionDetailsMui {...rest}>{children}</AccordionDetailsMui>
}

type AccordionSummaryProps = Pick<
  AccordionSummaryPropsMui,
  'children' | 'defaultChecked' | 'id' | 'aria-controls'
>

export const AccordionSummary: FC<AccordionSummaryProps> = ({ children, ...rest }) => {
  return (
    <AccordionSummaryMui
      sx={{
        '&': {
          mx: 0,
          my: 4,
          minHeight: 'auto !important'
        },
        '& .MuiAccordionSummary-content': {
          m: '0 !important'
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
          mx: 8,
          color: 'black'
        }
      }}
      expandIcon={<ArrowDropDownIcon />}
      {...rest}
    >
      {children}
    </AccordionSummaryMui>
  )
}
